import {Button, Input, Label } from 'reactstrap';
import React, { Component } from 'react';
import FontAwesome from 'react-fontawesome';

const UsersTable = (props) => {
    function renderCards(){
        let map = new Map();
        for(let i = 0; i < props.init.requestorTypes.length; i++){
            map.set(props.init.requestorTypes[i].Key, props.init.requestorTypes[i].Value);
        }
        // console.log('UsersTable props.users.length', props.users.length);
        if(props.users){
            let items = props.users.map((user,index) => (
                <div className="card" key={user.id} style={{marginBottom:'20px'}}>
                    <div className="card-body" style={{lineHeight:'2.5'}}>
                        <div className="d-md-none d-sm-block" style={{clear:'both'}}></div>
                        <div className="col-sm-6 col-md-1 float-right" style={{cursor:'pointer'}} onDoubleClick={(evt) => props.onUserUpdate(user)}><div className="d-md-none"><label>תעודת זהות</label></div>{!user.identityNumber ? '-' : user.identityNumber}</div>
                        <div className="col-sm-6 col-md-1 float-right" style={{cursor:'pointer'}} onDoubleClick={(evt) => props.onUserUpdate(user)}><div className="d-md-none"><label>שם מלא</label></div>{!user.fullName ? '-' : user.fullName}</div>
                        <div className="col-sm-6 col-md-1 float-right" style={{cursor:'pointer'}} onDoubleClick={(evt) => props.onUserUpdate(user)}><div className="d-md-none"><label>תפקיד</label></div>{!user.position ? '-' : user.position}</div>
                        {/* <div className="col-sm-6 col-md-2 float-right" style={{cursor:'pointer'}} onDoubleClick={(evt) => props.onUserUpdate(user)}><div className="d-md-none"><label>סוג גורם מבקש</label></div>{map.get(user.requestorType.toString())} &nbsp;</div> */}
                        <div className="col-sm-6 col-md-2 float-right" style={{cursor:'pointer'}} onDoubleClick={(evt) => props.onUserUpdate(user)}><div className="d-md-none"><label>ספקים</label></div>{user.vendors.length == 0 ? '-' : user.vendors.map(s => s.Value).join(', ')}</div>
                        <div className="col-sm-6 col-md-1 float-right" style={{cursor:'pointer'}} onDoubleClick={(evt) => props.onUserUpdate(user)}><div className="d-md-none"><label>איש קשר במשהב"ט</label></div>{!user.liaison ? '-' : user.liaison}</div>
                        <div className="col-sm-6 col-md-1 float-right" style={{cursor:'pointer'}} onDoubleClick={(evt) => props.onUserUpdate(user)}><div className="d-md-none"><label>טלפון</label></div>{!user.phone ? '-' : user.phone}</div>
                        <div className="col-sm-6 col-md-2 float-right" style={{cursor:'pointer'}} onDoubleClick={(evt) => props.onUserUpdate(user)}><div className="d-md-none"><label>דואר אלקטרוני</label></div>{!user.email ? '-' : user.email}</div>
                        <div className="d-md-block float-right d-none"><Button color="link" onClick={evt => props.onUserDelete(user)}><FontAwesome name="times"/> מחיקה</Button></div>
                    </div>
                    <div className="d-md-none d-sm-block" style={{borderTop:'1px solid #ddd'}}>
                        <div className="col-sm-6 d-md-none d-block float-right"><Button color="link" onClick={evt => props.onUserDelete(user)}><FontAwesome name="times"/> מחיקה</Button></div>
                    </div>
                </div>
            ));
            return items;
        }
        return null;
    }

    return (
        <div className="col-md-12" style={{display:'flex', flexDirection:'column', flexWrap:'nowrap', justifyContent: 'flex-start'}}>
        {props.users ? 
        <>
            <div className="card d-none d-md-block" style={{marginBottom:'20px', backgroundColor:'#EAEDF8', lineHeight:'0.5', boxShadow:'none'}}>
                <div className="card-body">
                    <div className="col-sm-1 float-right">תעודת זהות</div>
                    <div className="col-sm-1 float-right">שם מלא</div>
                    <div className="col-sm-1 float-right">תפקיד</div>
                    {/* <div className="col-sm-2 float-right">סוג גורם מבקש</div> */}
                    <div className="col-sm-2 float-right">ספקים</div>
                    <div className="col-sm-1 float-right">איש קשר</div>
                    <div className="col-sm-1 float-right">טלפון</div>
                    <div className="col-sm-2 float-right">דואר אלקטרוני</div>
                    <div className="float-right">&nbsp;</div>
                </div>
            </div>
            {renderCards()}
        </> : null}
    </div>
    );
  };
  
  export default UsersTable;
  